import { format, parseISO } from 'date-fns'
import type { CommitmentLetterVendor } from '@/api/commitmentLetters'

export function formatIsoDate(value: string | null | undefined): string {
  return value ? format(parseISO(value), 'M/d/yyyy') : '—'
}

export function vendorLabel(vendor: CommitmentLetterVendor): string {
  const number = vendor.vendor_code ?? vendor.vendor_id
  return [number, vendor.vendor_name].filter(Boolean).join(' - ') || 'Vendor'
}
